import { pb } from '@/lib/pocketbase';

export const initializeTutorTerms = async () => {
  try {
    // Check if terms already exist
    const existingTerms = await pb.collection('terms_versions')
      .getFirstListItem('agreement_type = "tutor_terms"')
      .catch(() => null);

    if (existingTerms) {
      console.log('Terms already exist');
      return existingTerms;
    }

    console.log('No terms found, creating default terms...');

    const defaultTermsContent = `
<h2>Tutor Service Agreement v1.0</h2>

<h3>1. Financial Terms</h3>
<ul>
  <li>Platform commission: 15% of each lesson fee</li>
  <li>Payments processed within 24-48 hours after lesson completion</li>
  <li>Full refund guarantee to students for any valid claims</li>
  <li>Tutor responsible for refunds in case of service issues</li>
  <li>Payment disputes handled through platform mediation</li>
</ul>

<h3>2. Tutor Responsibilities</h3>
<ul>
  <li>Maintain professional conduct at all times</li>
  <li>Provide high-quality educational content and instruction</li>
  <li>Be punctual and reliable for all scheduled sessions</li>
  <li>Verify identity and qualifications as required by the platform</li>
  <li>Respond to student messages within 24 hours during business days</li>
  <li>Maintain appropriate learning environment during video sessions</li>
  <li>Respect student privacy and confidentiality</li>
</ul>

<h3>3. Platform Protection & Legal Terms</h3>
<ul>
  <li>Tutor indemnifies platform against third-party claims arising from services</li>
  <li>Platform reserves right to suspend or terminate accounts for violations</li>
  <li>Dispute resolution through platform mediation process first</li>
  <li>Platform liability limited to direct damages up to lesson fee amount</li>
  <li>Tutor cannot circumvent platform to conduct direct transactions</li>
</ul>

<h3>4. Refund & Cancellation Policy</h3>
<ul>
  <li>Students entitled to full refund for lessons cancelled 24+ hours in advance</li>
  <li>Full refund for technical issues preventing lesson delivery</li>
  <li>Partial or full refund for lessons not meeting platform quality standards</li>
  <li>Platform handles all refund processing and communication</li>
  <li>Tutors may contest refund requests through appeal process</li>
</ul>

<h3>5. Data & Privacy</h3>
<ul>
  <li>Tutor data processed according to platform privacy policy</li>
  <li>Student information must be kept confidential</li>
  <li>No sharing of student data outside platform</li>
  <li>Recording of lessons requires explicit student consent</li>
</ul>

<h3>6. Termination</h3>
<ul>
  <li>Either party may terminate agreement with 30 days notice</li>
  <li>Platform may immediately suspend for policy violations</li>
  <li>Outstanding payments processed according to normal schedule</li>
  <li>Data retention according to platform privacy policy</li>
</ul>

<p><strong>By clicking "I Agree", you acknowledge that you have read, understood, and agree to be bound by these terms.</strong></p>
    `;

    // Create initial terms
    const termsData = {
      version: '1.0',
      title: 'Tutor Service Agreement',
      content: defaultTermsContent.trim(),
      effective_date: new Date().toISOString(),
      is_current: true,
      agreement_type: 'tutor_terms'
    };

    const newTerms = await pb.collection('terms_versions').create(termsData);
    console.log('Created initial terms:', newTerms);
    return newTerms;
  } catch (error) {
    console.error('Error initializing terms:', error);
    throw error;
  }
};